export {
    AppRouterStyleRegistry,
    type AppRouterStyleRegistryProps,
} from './app-router-style-registry';

// Re-export functionality for "Pages Router" server-side rendering (SSR)
export { renderStyles } from '@gs-ux-uitoolkit-react/style-ssr';
export { type RenderStylesOptions } from '@gs-ux-uitoolkit-common/style-ssr';
